(() => {
  const D = '#MainContent[data-template^="product"] .product-details';
  const P = 'product-price[data-block-id="price_sg"] [ref="priceContainer"],product-price [ref="priceContainer"]';
  const MONEY = /R\$\s*\d[\d.]*,\d{2}(?:\s*BRL)?/i;
  const QTY = /\b(\d+)\s*(unidade|unidades)\b/i;
  const MODE = /compra\s*(unica|avulsa)|assinatura|assine|subscribe|subscription|one[- ]?time/i;
  const txt = (e) => e instanceof Element ? (e.textContent || '').replace(/\s+/g, ' ').trim() : '';
  const norm = (v) => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  const money = (v) => ((String(v || '').match(MONEY) || [''])[0]).replace(/\s*BRL\b/gi, '').trim();
  const qty = (e) => Number((txt(e).match(QTY) || [0, 0])[1] || 0);

  function priceSnapshot(details) {
    const box = details.querySelector(P);
    if (!(box instanceof HTMLElement)) return null;
    const current = money(box.dataset.sgPurchasePrice || txt(box.querySelector('.price')));
    const compare = money(box.dataset.sgPurchaseCompare || txt(box.querySelector('.compare-at-price')));
    return current ? { current, compare: compare && compare !== current ? compare : '' } : null;
  }

  function root(details) {
    const explicit = [...details.querySelectorAll('[id*="super_subscriptions_bundles_product_block"],[id*="super-subscriptions"],[data-block-id*="super_subscriptions_bundles"]')];
    const ok = (e) => {
      const t = norm(txt(e));
      return t.includes('compre mais e economize') || t.includes('escolha a melhor opcao') || (e.querySelectorAll('input[type="radio"]').length > 1 && t.includes('1 unidade') && t.includes('2 unidades'));
    };
    const list = explicit.filter(ok);
    if (list.length) return list.sort((a,b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length)[0];
    const fallback = [...details.querySelectorAll('div,section,form,fieldset')].filter(ok);
    return fallback.sort((a,b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length)[0] || null;
  }

  function cardFor(input, r, wantQty = true) {
    let n = input.closest('label');
    if (n && r.contains(n)) {
      const t = txt(n);
      if (wantQty ? qty(n) && MONEY.test(t) : MODE.test(norm(t)) && !qty(n)) return n;
    }
    n = input.parentElement;
    for (let i = 0; n && n !== r && i < 8; i++, n = n.parentElement) {
      const t = txt(n);
      if (wantQty) {
        const qs = [...t.matchAll(/\b\d+\s*(?:unidade|unidades)\b/gi)];
        if (qs.length === 1 && MONEY.test(t)) return n;
      } else if (MODE.test(norm(t)) && !qty(n)) return n;
    }
    return null;
  }

  function common(items, r) {
    let n = items[0]?.parentElement;
    while (n) {
      if (items.every((x) => n.contains(x))) return n;
      if (n === r) return r;
      n = n.parentElement;
    }
    return r;
  }

  function childAt(item, parent) {
    let n = item;
    while (n.parentElement && n.parentElement !== parent) n = n.parentElement;
    return n;
  }

  function leaves(box) {
    return [...box.querySelectorAll('span,strong,b,div,p,small,s,del')].filter((e) => txt(e) && ![...e.children].some((c) => txt(c)));
  }

  function stripBrl(r) {
    const w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT);
    const ns = [];
    while (w.nextNode()) ns.push(w.currentNode);
    ns.forEach((n) => { if (/\bBRL\b/i.test(n.nodeValue || '')) n.nodeValue = n.nodeValue.replace(/\s*BRL\b/gi, ''); });
  }

  function syncOne(card, snap) {
    const ls = leaves(card);
    const current = ls.filter((e) => MONEY.test(txt(e)) && !e.matches('s,del') && !/line-through/i.test(e.getAttribute('style') || '') && !/\/\s*unidade|por\s+unidade/i.test(norm(txt(e)))).pop();
    if (current) {
      current.classList.add('sg-super-price');
      const old = money(txt(current));
      if (old && old !== snap.current) current.textContent = txt(current).replace(MONEY, snap.current);
    }
    let compare = card.querySelector('[data-sg-super-compare]');
    if (snap.compare) {
      if (!(compare instanceof HTMLElement)) {
        compare = document.createElement('s');
        compare.dataset.sgSuperCompare = '1';
        compare.className = 'sg-super-compare sg-super-compare--generated';
        card.append(compare);
      }
      compare.textContent = snap.compare;
    } else compare?.remove();
  }

  function markQty(r, snap) {
    const cards = [];
    r.querySelectorAll('input[type="radio"]').forEach((input) => {
      const c = cardFor(input, r, true);
      if (c && !cards.includes(c)) cards.push(c);
    });
    const qs = cards.filter(qty);
    if (!qs.length) return;

    qs.forEach((c) => {
      const q = qty(c), radio = c.querySelector('input[type="radio"]');
      c.classList.add('sg-super-card', `sg-super-q${q}`);
      c.classList.toggle('sg-super-selected', radio instanceof HTMLInputElement && radio.checked);
      leaves(c).forEach((e) => {
        const t = txt(e), n = norm(t);
        if (QTY.test(t) && !MONEY.test(t)) e.classList.add('sg-super-title');
        const saveMatch = t.match(/(?:economize\s*)?(\d+)\s*%\s*(?:off)?/i);
        if (saveMatch && (/economize/i.test(t) || /%\s*off/i.test(t))) {
          e.classList.add('sg-super-save');
          const desired = `${saveMatch[1]}% OFF`;
          if (t !== desired) e.textContent = desired;
        }
        if ((e.matches('s,del') || /line-through/i.test(e.getAttribute('style') || '')) && MONEY.test(t)) e.classList.add('sg-super-compare');
        if (MONEY.test(t) && (/\/\s*unidade/i.test(t) || /por\s+unidade/i.test(n))) e.classList.add('sg-super-unit');
      });
      const ps = leaves(c).filter((e) => MONEY.test(txt(e)) && !e.classList.contains('sg-super-compare') && !e.classList.contains('sg-super-unit'));
      ps.at(-1)?.classList.add('sg-super-price');
    });

    const g = common(qs, r);
    g.classList.add('sg-super-grid');
    g.style.setProperty('--sg-cols', String(Math.min(qs.length, 4)));
    qs.forEach((c) => childAt(c, g).classList.add('sg-super-grid-item'));
    const one = qs.find((c) => qty(c) === 1);
    if (one && snap) syncOne(one, snap);
  }

  function markModes(r) {
    const cards = [];
    r.querySelectorAll('input[type="radio"]').forEach((input) => {
      if (cardFor(input, r, true)) return;
      const c = cardFor(input, r, false);
      if (c && !cards.includes(c)) cards.push(c);
    });
    if (!cards.length) return;
    cards.forEach((c) => {
      const radio = c.querySelector('input[type="radio"]');
      c.classList.add('sg-super-mode');
      c.classList.toggle('sg-super-selected', radio instanceof HTMLInputElement && radio.checked);
    });
    if (cards.length > 1) {
      const g = common(cards, r);
      g.classList.add('sg-super-mode-grid');
      cards.forEach((c) => childAt(c, g).classList.add('sg-super-mode-item'));
    }
  }

  function markText(r) {
    leaves(r).forEach((e) => {
      const n = norm(txt(e));
      if (n.includes('compre mais e economize') || n.includes('escolha a melhor opcao')) e.classList.add('sg-super-heading');
      if (n.includes('subscription widget will only appear')) e.classList.add('sg-super-editor-note');
    });
  }

  function sync(details) {
    const r = root(details);
    if (!r) return;
    r.classList.add('sg-super-widget');
    stripBrl(r);
    markText(r);
    markQty(r, priceSnapshot(details));
    markModes(r);
    r.querySelectorAll('select').forEach((e) => e.classList.add('sg-super-select'));
  }

  function init() {
    const details = document.querySelector(D);
    if (!(details instanceof HTMLElement)) return;
    let busy = false;
    const run = () => {
      if (busy) return;
      busy = true;
      requestAnimationFrame(() => { busy = false; sync(details); });
    };
    run(); [100,350,800,1600].forEach((ms) => setTimeout(run, ms));
    if (details.dataset.sgSuperReady) return;
    details.dataset.sgSuperReady = '1';
    new MutationObserver((ms) => { if (ms.some((m) => m.type === 'characterData' || (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)))) run(); })
      .observe(details, { subtree:true, childList:true, characterData:true });
    details.addEventListener('change', () => { setTimeout(run,0); setTimeout(run,100); });
    details.addEventListener('click', () => setTimeout(run,40));
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once:true }) : init();
  document.addEventListener('shopify:section:load', () => setTimeout(init,50));
})();
